<template>
  <v-dialog
  persistent
  max-width="450"
  v-model="showIntroModal"
  transition=false
  :fullscreen="$vuetify.breakpoint.xsOnly"
  content-class="intro-modal"
  scrollable
  >
  <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-container class="modal-pad" style="overflow: auto;">
        <v-layout row align-center wrap mb-3>
          <v-flex xs12 style="height:30px;">
            <span class="subheading">Let's get started&hellip;</span>
          </v-flex>
        </v-layout>
        <v-layout column wrap>
          <v-flex >
            <v-text-field
              name="groupTitle"
              label="Business Name"
              id="groupTitle"
              v-model="group.title"
              placeholder=" "
              type="text"
              :rules="[rules.required]"
              required></v-text-field>

              <a class="localtoggle" @click="showLocalisationOptions = !showLocalisationOptions">
                {{ group.tz }}, {{ chosenCurrency.code }}<v-icon>place</v-icon>

              </a>
              <transition name="fade">
                <div v-if="showLocalisationOptions">
              <v-autocomplete
              :items="timezones"
              v-model="group.tz"
              label="Timezone"
              ref="focus"
            >
          </v-autocomplete>

            <v-autocomplete
              v-bind:items="currencies"
              item-value="code"
              v-model="chosenCurrency"
              label="Currency"
              :menu-props="{ bottom: true }"
              return-object
            >
            <template slot="selection" slot-scope="data">
              {{ data.item.name }} {{ data.item.symbol }}
            </template>
            <template slot="item" slot-scope="data">
              {{ data.item.name }} {{ data.item.symbol }}
            </template>
            </v-autocomplete>
          </div>
            </transition>
          </v-flex>
          <v-flex>
            <p class="caption light text-xs-left mb-0">Does your business charge Tax (VAT, GST, Sales Tax)?</p>
            <v-radio-group  v-model='group.chargeTax' hide-details row class="mt-0 pt-2 mb-3">
                <v-radio color="primary" label="Yes" :value='true' ></v-radio>
                <v-radio color="primary" label="No" :value='false'></v-radio>
              </v-radio-group>
              <p class="caption" v-if='group.chargeTax'>By default we will show all your job and invoice totals exclusive of {{ group.taxLabel }}. You can change this within Settings > Business</p>
          </v-flex>
        </v-layout>
        <v-layout align-end justify-start row mt-3>
          <v-btn :disabled='!allowSave' large depressed color="primary" @click="saveGroupDetails()">Begin</v-btn>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Timezones from '@/data/IANAtimezones.js'
import Currencies from '@/data/currencies.js'
import TaxChoices from '@/components/Shared/TaxChoices'
export default {
  name: 'IntroModal',
  components: {
    TaxChoices
  },
  data () {
    return {
      showIntroModal: true,
      showLocalisationOptions: false,
      hideTaxOptions: true,
      user: this.$store.getters.user,
      group: this.$store.getters.group,
      currencies: Currencies,
      timezones: Timezones,
      // maybe in future at some point
      // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      // for now use the ipdata
      chosenCurrency: {
        code: this.$store.getters.group.currCode,
        symbol: this.$store.getters.group.currSymbol
      },
      rules: {
        required: value => !!value || 'Required, we need this!'
      }
    }
  },
  computed: {
    allowSave () {
      return this.group.title
    }
  },
  watch: {
    showIntroModal (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    },
    chosenCurrency: function (val) {
      // takes the returning currency select object and splits it into its bits
      this.group.currCode = val.code
      this.group.currSymbol = val.symbol
    }
  },
  methods: {
    saveGroupDetails () {
      // set a flag to not show intro again
      this.group.introDone = true
      // fire store group update
      this.$store.dispatch('updateGroupSettings', this.group)
      // hide the modal
      this.showIntroModal = false
      // start the tour
      this.$emit('start-tour')
    }
  }
}
</script>

<style lang="scss" scoped>

.localtoggle {
  text-align:right;
  display:block;
  margin-top:-5px;
  z-index:999;
  margin-bottom:30px;
}

.modal{
  border-radius:7px;
  overflow:hidden;
}

.bg-white{
  background: #fff;
}
ul.checklist{
  margin:0;
  padding:0;
  list-style:none;
  li{
    list-style-type:none;
    padding:4px 0;
    margin:0;
    font-size:.85rem;
  }
}
a.h-logohold{
  text-decoration:none;
  display:flex;
  justify-content: center;
  align-items: center;
  span{
    margin-left:10px;
    font-size:1.9rem !important;
  }
  svg.h-logo{
    display:inline-block;
      width:15px;
      height:15px;
      margin-bottom:0px;
      rect{
        fill:var(--green);
      }
    }
}

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
